import { useQuery } from '@tanstack/react-query';
import { desktopAuthApi } from './desktop-auth.api';
import { desktopAuthKeys } from './desktop-auth.keys';
import type { DesktopAuthorizeParams } from '../types/desktop-auth.type';

/** 같은 요청을 다시 검증할 이유가 없다 — 재시도·재조회 없이 한 번만 본다. */
export function useDesktopAuthorizePreview(
  params: DesktopAuthorizeParams | null,
) {
  return useQuery({
    queryKey: params ? desktopAuthKeys.preview(params) : desktopAuthKeys.all,
    queryFn: () => desktopAuthApi.preview(params as DesktopAuthorizeParams),
    enabled: !!params,
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
